module.exports = __webpack_public_path__ + "img/wide.17e7f334.jpg";